import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Divider,
  ListItemIcon,
  Typography,
  Box,
  Badge,
} from "@mui/material";
import {
  Settings,
  Logout,
  Person,
  ShoppingBag,
  Star,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const PRIMARY_COLOR = "#2E4053";
// const ACCENT_COLOR = "#D35400";
const ACCENT_COLOR = "#8B4513";

const ShopUserMenu = ({ user, handleLogout }) => {
  const [anchorSettings, setAnchorSettings] = useState(null);
  const navigate = useNavigate();

  const isLoggedIn = !!user;

  return (
    <>
      <IconButton
        color="inherit"
        onClick={(e) => setAnchorSettings(e.currentTarget)}
        size="large"
      >
        <Settings sx={{ color: "#fff" }} />
      </IconButton>

      <Menu
        anchorEl={anchorSettings}
        open={Boolean(anchorSettings)}
        onClose={() => setAnchorSettings(null)}
        PaperProps={{
          sx: {
            mt: 1,
            width: 260,
            p: 1,
            bgcolor: PRIMARY_COLOR,
            color: "#fff",
            "& .MuiMenuItem-root": {
              "&:hover": { backgroundColor: ACCENT_COLOR },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {isLoggedIn ? (
          <>
            {/* User Info */}
            <Box sx={{ display: "flex", alignItems: "center", px: 2, py: 1 }}>
              <Avatar sx={{ mr: 1, bgcolor: ACCENT_COLOR }}>
                {user.name?.[0] || "U"}
              </Avatar>
              <Box>
                <Typography variant="subtitle1">
                  {user.name || "User"}
                </Typography>
                <Typography
                  variant="body2"
                  color="inherit"
                  sx={{ opacity: 0.8 }}
                >
                  {user.email || ""}
                </Typography>
              </Box>
            </Box>

            <Divider sx={{ my: 1, borderColor: "#4a4a4a" }} />

            {/* Menu Items */}
            <MenuItem onClick={() => navigate("/orders")}>
              <ListItemIcon sx={{ color: "#fff" }}>
                <ShoppingBag fontSize="small" />
              </ListItemIcon>
              My Orders
            </MenuItem>

            <MenuItem onClick={() => navigate("/profile")}>
              <ListItemIcon sx={{ color: "#fff" }}>
                <Person fontSize="small" />
              </ListItemIcon>
              Account Settings
            </MenuItem>

            <MenuItem onClick={() => navigate("/rewards")}>
              <ListItemIcon sx={{ color: "#fff" }}>
                <Star fontSize="small" />
              </ListItemIcon>
              Reward Points
              {user.rewardPoints !== undefined && (
                <Badge
                  badgeContent={user.rewardPoints}
                  color="primary"
                  sx={{ ml: 1 }}
                />
              )}
            </MenuItem>

            <Divider sx={{ my: 1, borderColor: "#4a4a4a" }} />

            <MenuItem onClick={handleLogout} sx={{ color: "error.main" }}>
              <ListItemIcon sx={{ color: "error.main" }}>
                <Logout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </>
        ) : (
          <>
            <MenuItem onClick={() => navigate("/shop/customerlogin")}>
              Login
            </MenuItem>
            <MenuItem onClick={() => navigate("/shop/customerRegister")}>
              Sign Up
            </MenuItem>
          </>
        )}
      </Menu>
    </>
  );
};

export default ShopUserMenu;
